const reportFormSend = () => {
    if(document.querySelector( '.form-report .wpcf7' ) != null){
        const formReport = document.querySelector( '.form-report .wpcf7' );
        const thxReport = document.querySelector( '.form-report .popup__thx' );

        formReport.addEventListener( 'wpcf7mailsent', function( event ) {
            const linkToDwn = formReport.querySelector('.form-diz__hidden input').value;
            const linkElem = document.createElement('a');
            linkElem.href = linkToDwn;
            const fileNameArr = linkToDwn.split('/');
            const fileName = fileNameArr[fileNameArr.length - 1];
            linkElem.download = fileName;
            linkElem.dispatchEvent(new MouseEvent('click'));
            thxReport.classList.add('active');
        }, false );
    }
}

module.exports = reportFormSend;